<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <mask id="path-1-inside-1_1683_973" fill="white">
    <path
      d="M1 12C3.84249 9.44176 8.15751 9.44176 11 12V15H1V12ZM6 1C7.933 1 9.5 2.567 9.5 4.5C9.5 6.433 7.933 8 6 8C4.067 8 2.5 6.433 2.5 4.5C2.5 2.567 4.067 1 6 1Z"
    />
  </mask>
  <path
    d="M1 12L-0.00344706 10.8851L-0.5 11.332V12H1ZM11 12H12.5V11.332L12.0034 10.8851L11 12ZM11 15V16.5H12.5V15H11ZM1 15H-0.5V16.5H1V15ZM1 12L2.00345 13.1149C4.27548 11.0701 7.72452 11.0701 9.99655 13.1149L11 12L12.0034 10.8851C8.5905 7.81341 3.4095 7.81341 -0.00344706 10.8851L1 12ZM11 12H9.5V15H11H12.5V12H11ZM11 15V13.5H1V15V16.5H11V15ZM1 15H2.5V12H1H-0.5V15H1ZM6 1V2.5C7.10457 2.5 8 3.39543 8 4.5H9.5H11C11 1.73858 8.76142 -0.5 6 -0.5V1ZM9.5 4.5H8C8 5.60457 7.10457 6.5 6 6.5V8V9.5C8.76142 9.5 11 7.26142 11 4.5H9.5ZM6 8V6.5C4.89543 6.5 4 5.60457 4 4.5H2.5H1C1 7.26142 3.23858 9.5 6 9.5V8ZM2.5 4.5H4C4 3.39543 4.89543 2.5 6 2.5V1V-0.5C3.23858 -0.5 1 1.73858 1 4.5H2.5Z"
    fill="currentColor"
    mask="url(#path-1-inside-1_1683_973)"
  />
  <path
    d="M12.5 10.5117C13.3995 10.8306 14.2511 11.326 15 12V15H12.5V13.5H13.5V12.7148C13.1823 12.4847 12.8471 12.2899 12.5 12.1299V10.5117ZM10 1C11.933 1 13.5 2.567 13.5 4.5C13.5 6.433 11.933 8 10 8C9.86185 8 9.72577 7.99018 9.5918 7.97461C10.0292 7.52253 10.3831 6.98962 10.626 6.39844C11.4237 6.13555 12 5.38576 12 4.5C12 3.61413 11.4238 2.86339 10.626 2.60059C10.383 2.00951 10.0292 1.47638 9.5918 1.02441C9.72574 1.00885 9.86188 1 10 1Z"
    fill="currentColor"
  />
</svg>
